import { useCallback, useEffect, useState } from "react";
import { IUserDetailsInfo } from "../../interface/IUserDetails";
import { getContactDetailsRoute } from "@api-routes/contacts";
import { getResponseToState, IUserContactResponse } from "../mappers/getUserDetailsMapper";
import { useUserContext } from "@hook/useUserContext";
import { useFetch } from "@common/hook/useFetch";

export const useGetUserContact = () => {
    const [userDetails, setUserDetails] = useState<IUserDetailsInfo>();
    const [getUserDetailsState, { get }] = useFetch();
    const { username: contactUuid } = useUserContext();

    const getUserDetails = useCallback(() => {
        if (contactUuid) {
            get<IUserContactResponse>(getContactDetailsRoute(contactUuid)).then((userContactResponse) => {
                if (userContactResponse) {
                    setUserDetails(getResponseToState(userContactResponse));
                }
            });
        }
    }, [contactUuid, get]);

    useEffect(getUserDetails, [getUserDetails]);

    return { userDetails, getUserDetailsState, getUserDetails };
};
